// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__HgQNR","page":"pagination_page__Q00tQ","page_active":"pagination_page_active__FF5vs"};